import { configureStore } from '@reduxjs/toolkit';
import invoiceDataReducer from '../slices/invoiceData.slice';
import countReducer from '../slices/count.slice';
import loadingReducer from '../slices/loading.slice'

export const store = configureStore({
    reducer: {
      invoiceData: invoiceDataReducer,
      counts: countReducer,
      loading: loadingReducer
    },
  });

// Get the type of our store variable
export type AppStore = typeof store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch'];
